import { Credentials } from '@/models/login/credentials';
import { authService } from '@/services/auth-service';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LoginComponent extends Vue {
    isUserExist?: boolean = null;
    progress: boolean = false;
    credentials: Credentials = new Credentials();

    get username() { return this.credentials.username; }
    set username(value) { this.credentials.username = value }

    get password() { return this.credentials.password; }
    set password(value) { this.credentials.password = value; }

    get showUserLoginError() { return this.isUserExist === false; }

    public async onSignOnClick() {
        try {
            await authService.logIn(this.credentials);

            this.isUserExist = true;

            if (this.$route.query.redirectUrl != null) {
                this.$router.push(this.$route.query.redirectUrl as string);
            } else {
                this.$router.push('/');
            }
        } catch {
            this.isUserExist = false;
        }
    }
}
